import { fetchData, uploadData } from '../utils/api';

export const categoryService = {
  async getCategories() {
    const response = await fetchData('/categories');
    return response.categories || [];
  },

  async createCategory(formData) {
    const response = await uploadData('/categories', formData);
    return response.category;
  },

  async updateCategory(id, formData) {
    const response = await uploadData(`/categories/${id}`, formData, 'PUT');
    return response.category;
  },

  async deleteCategory(id) {
    const response = await fetchData(`/categories/${id}`, { method: 'DELETE' });
    return response;
  },
};